import styled from 'styled-components';
import { Typography } from 'src/typography';

export const TabBarContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
  border-bottom: 1px solid var(--dcm-color-border);
  margin-bottom: 14px;
  @media screen and (max-width: 600px) {
    gap: 10px;
    border-bottom: none;
  }
`;

export const Tab = styled.button`
  display: flex;
  align-items: center;
  min-height: 55px;
  padding: 0 ${({ theme }) => theme.spaces[1]} 0 0;
  border: none;
  border-bottom: 2px solid transparent;
  background: none;
  cursor: pointer;
  color: var(--dcm-color-text-secondary);
  outline: none;

  &:focus-visible {
    outline: 2px solid var(--dcm-color-primary);
    outline-offset: 2px;
  }

  &[aria-selected='true'] {
    border-bottom-color: var(--dcm-color-primary);
    color: var(--dcm-color-primary);
  }

  @media screen and (max-width: 600px) {
    min-height: unset;
    border-bottom: none;
    border-radius: 1000px;
    padding: 8px 20px;
    background-color: var(--dcm-referral-tab-inactive-bg);

    &[aria-selected='true'] {
      background-color: var(--dcm-color-primary);
    }
  }
`;

export const TabText = styled(Typography.Body)`
  line-height: 20px;
  color: var(--dcm-color-text-primary);

  ${Tab}[aria-selected='true'] & {
    color: var(--dcm-color-primary);
  }

  @media screen and (max-width: 600px) {
    color: var(--dcm-color-text-secondary);

    ${Tab}[aria-selected='true'] & {
      color: var(--dcm-color-text-inverted);
    }
  }
`;
